module.exports = __webpack_public_path__ + "static/testimonialbackground-22ac64d45854686661bdf674b3b57870.jpg";